import Swiper from 'swiper/dist/js/swiper.min';

let swipers = [];
let count = 1;
let fullSliders = document.querySelectorAll('.c-slider--full');
if (fullSliders) {
    Array.prototype.forEach.call(fullSliders, function (full) {
        full.classList.add('f' + count);
        swipers.push(new Swiper('.f' + count, {
            speed: 500,
            slidesPerView: 2,
            spaceBetween: 32,
            // Navigation arrows
            navigation: {
                nextEl: '.c-slider__arrow--next',
                prevEl: '.c-slider__arrow--prev',
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1.25,
                },
            },
        }));
        count++;
    });
}
let reviewSliders = document.querySelectorAll('.c-slider--review');
if (reviewSliders) {
    Array.prototype.forEach.call(reviewSliders, function (review) {
        review.classList.add('r' + count);
        swipers.push(new Swiper('.r' + count, {
            effect: 'fade',
            speed: 500,
            slidesPerView: 1,
            // Navigation arrows
            navigation: {
                nextEl: '.c-slider__arrow--next',
                prevEl: '.c-slider__arrow--prev',
            },
        }));
        count++;
    });
}
let compactSliders = document.querySelectorAll('.c-slider--compact');
if (compactSliders) {
    Array.prototype.forEach.call(compactSliders, function (compact) {
        compact.classList.add('s' + count);
        swipers.push(new Swiper('.s' + count, {
            effect: 'fade',
            speed: 500,
            // Navigation arrows
            navigation: {
                nextEl: '.c-slider__arrow--next',
                prevEl: '.c-slider__arrow--prev',
            },
            // If we need pagination
            pagination: {
                el: '.c-slider__pagination',
                currentClass: 'c-slider__pagination--current',
                totalClass: 'c-slider__pagination--total',
                type: 'fraction',
                formatFractionTotal: function (number) {
                    if (number < 10) {
                        return '0' + number;
                    }
                    return number;
                },
                formatFractionCurrent: function (number) {
                    if (number < 10) {
                        return '0' + number;
                    }
                    return number;
                },
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' +
                            '<span class="' + totalClass + '"></span>';
                }
            },
        }));
        count++;
    });
}
